// src/HomePage/Game/FolkGame/OAnQuan/OAnQuanBoard.js
import React, { useState } from 'react';
import { isPlayer1Square, isPlayer2Square, isQuanSquare } from './OAnQuanLogic';
import './OAnQuanBoard.css';

const OAnQuanBoard = ({
  board,
  isPlayer1,
  onSelectMove,
  disabled,
  activeCellIndex,
  eatenCellIndex,
  handStones,
  isFirstTurn
}) => {
  const [selectedIdx, setSelectedIdx] = useState(null);

  // POV: Người chơi luôn ở hàng dưới (Bottom), Đối thủ ở hàng trên (Top)
  const topRowIndices = isPlayer1 ? [10, 9, 8, 7, 6] : [4, 3, 2, 1, 0];
  const bottomRowIndices = isPlayer1 ? [0, 1, 2, 3, 4] : [6, 7, 8, 9, 10];
  const leftMandarinIdx = isPlayer1 ? 11 : 5;
  const rightMandarinIdx = isPlayer1 ? 5 : 11;

  const leftMandarinTitle = isPlayer1 ? 'QUAN TÂY' : 'QUAN ĐÔNG';
  const rightMandarinTitle = isPlayer1 ? 'QUAN ĐÔNG' : 'QUAN TÂY';

  const handleCellClick = (idx) => {
    if (disabled || isQuanSquare(idx) || board[idx] === 0) return;
    if (isPlayer1 && !isPlayer1Square(idx)) return;
    if (!isPlayer1 && !isPlayer2Square(idx)) return;
    setSelectedIdx(selectedIdx === idx ? null : idx);
  };

  const handleChooseDirection = (direction) => {
    if (selectedIdx !== null) {
      onSelectMove(selectedIdx, direction);
      setSelectedIdx(null);
    }
  };

  return (
    <div className="oanquan-breakout-container">
      <div className="oanquan-board-wrapper">
        {/* 1. Ô QUAN BÊN TRÁI */}
        <div
          className={`oanquan-mandarin-box left ${activeCellIndex === leftMandarinIdx ? 'active-drop' : ''} ${eatenCellIndex === leftMandarinIdx ? 'eaten' : ''}`}
        >
          {isFirstTurn && (
            <div className="oanquan-quan-lock-overlay left">
              <span className="oanquan-lock-icon">🔒</span>
              <span className="oanquan-lock-text">KHÓA</span>
            </div>
          )}
          <span className="oanquan-mandarin-crown">👑</span>
          <span className="oanquan-mandarin-title">{leftMandarinTitle}</span>
          <span className="oanquan-mandarin-stones">{board[leftMandarinIdx]} 🪨</span>
        </div>

        {/* 2. KHUNG 10 Ô DÂN Ở GIỮA */}
        <div className="oanquan-citizen-grid">
          {/* HÀNG TRÊN: Đối thủ */}
          <div className="oanquan-citizen-row top">
            {topRowIndices.map((idx) => {
              const isActiveDrop = activeCellIndex === idx;
              const isEaten = eatenCellIndex === idx;

              return (
                <div
                  key={idx}
                  className={`oanquan-cell-box opponent-cell ${isActiveDrop ? 'active-drop' : ''} ${isEaten ? 'eaten' : ''}`}
                >
                  <span className="oanquan-cell-num">Ô {idx + 1}</span>
                  <span className="oanquan-cell-stones">{board[idx]}</span>
                </div>
              );
            })}
          </div>

          {/* HÀNG DƯỚI: Bạn */}
          <div className="oanquan-citizen-row bottom">
            {bottomRowIndices.map((idx) => {
              const isPlayable = board[idx] > 0 && !disabled;
              const isSelected = selectedIdx === idx;
              const isActiveDrop = activeCellIndex === idx;
              const isEaten = eatenCellIndex === idx;

              return (
                <div
                  key={idx}
                  className={`oanquan-cell-box my-cell ${isPlayable ? 'playable' : ''} ${isSelected ? 'selected' : ''} ${isActiveDrop ? 'active-drop' : ''} ${isEaten ? 'eaten' : ''}`}
                  onClick={() => handleCellClick(idx)}
                >
                  {/* POPOVER NỔI CHỌN HƯỚNG (Không che khuất số sỏi) */}
                  {isSelected && (
                    <div className="oanquan-arrow-popover">
                      <button
                        className="oanquan-popover-btn left-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChooseDirection('ccw');
                        }}
                        title="Rải sang trái"
                      >
                        ⬅️
                      </button>
                      <button
                        className="oanquan-popover-btn right-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleChooseDirection('cw');
                        }}
                        title="Rải sang phải"
                      >
                        ➡️
                      </button>
                    </div>
                  )}

                  <span className="oanquan-cell-num">Ô {idx + 1}</span>
                  <span className="oanquan-cell-stones">{board[idx]}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* 3. Ô QUAN BÊN PHẢI */}
        <div
          className={`oanquan-mandarin-box right ${activeCellIndex === rightMandarinIdx ? 'active-drop' : ''} ${eatenCellIndex === rightMandarinIdx ? 'eaten' : ''}`}
        >
          {isFirstTurn && (
            <div className="oanquan-quan-lock-overlay right">
              <span className="oanquan-lock-icon">🔒</span>
              <span className="oanquan-lock-text">KHÓA</span>
            </div>
          )}
          <span className="oanquan-mandarin-crown">👑</span>
          <span className="oanquan-mandarin-title">{rightMandarinTitle}</span>
          <span className="oanquan-mandarin-stones">{board[rightMandarinIdx]} 🪨</span>
        </div>

        {/* 4. CHỈ BÁO SỎI ĐANG CẦM TRÊN TAY */}
        {handStones > 0 && (
          <div className="oanquan-hand-indicator">
            <span>Tay đang cầm: <b>{handStones}</b> 🪨</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OAnQuanBoard;